import { object } from "prop-types";
import { nodeListToArray } from "../helpers/nodeListToArray";

export { }


declare global {
    interface Window {
        sendSelectItemAnalyticsScriptToGTM: (element: any, itemKey: string, itemTitle: string, itemPrice: string, itemCategory: string, listId: string, listName: string) => void;
        sendAddToCartScriptToGTM: (element: any) => void;
    }
}

window.sendSelectItemAnalyticsScriptToGTM = function (element: any, itemKey: string, itemTitle: string, itemPrice: string, itemCategory: string, listId: string, listName: string) {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

    var tag = {
        'event': 'select_item',
        'ecommerce':
        {
            'item_list_id': listId,
            'item_list_name': listName,
            'items': [
                {
                    'item_id': itemKey,
                    'item_name': itemTitle,
                    'price': itemPrice,
                    'item_category': itemCategory
                }
            ]
        }
    };

    console.log(`Sending tag to data layer: ${JSON.stringify(tag)}`);
    (window as any).dataLayer.push(tag);
}

function sendViewListAnalyticsScriptToGTM(itemElements: Array<Element>, listId: string, listName: string) {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

    let items = getListItems(itemElements); 
    let tag = {
        'event': 'view_item_list',
        'ecommerce':
        {
            'item_list_id': listId,
            'item_list_name': listName,
            'items': items
        }
    };

    console.log(`Sending tag to data layer: ${JSON.stringify(tag)}`);
    (window as any).dataLayer.push(tag);
}

function getListItems(items: Array<Element>) {
    if (items && items.length > 0) {
        let listItems = [];
        items.forEach((item, index) =>
        {
            //get info about each product item via data attributes
            var title = item.getAttribute('data-product-carousel-item-title');
            var itemId = item.getAttribute('data-product-carousel-item-id');
            var itemPrice = item.getAttribute('data-product-carousel-item-price');
            var itemCategory = item.getAttribute('data-product-carousel-item-category');

            //Parse out additional HTML from the title.
            var e = document.createElement('div');
            e.innerHTML = title;
            title = e.textContent ? e.textContent : e.innerText;

            let listItem = getListItem(itemId, title, itemPrice, itemCategory);
            listItems.push(listItem);
        }
        )
        return listItems;
    }
    return [];
}

function getListItem(itemKey: string, itemTitle: string, itemPrice: string, itemCategory: string) {
    let listItem = {
        'item_id': itemKey,
        'item_name': itemTitle,
        'price': itemPrice,
        'item_category': itemCategory
    }
    return listItem;
}

export function sendVisibleCarouselItemsListScriptToGTM(carouselElement: Element) {
    let visibleCarouselItems = getVisibleCarouselItems(carouselElement);
    let listId = "";
    let listName = "";

    if (carouselElement) {
        listId = carouselElement.getAttribute('data-unique-id');
        const carouselTitle = carouselElement.querySelector('[data-product-carousel-title]');
        if (carouselTitle) {
            listName = (carouselTitle as HTMLElement).innerText;
        }
    }

    sendViewListAnalyticsScriptToGTM(visibleCarouselItems, listId, listName);
}

function getVisibleCarouselItems(carouselElement: Element) : Array<Element> {
    let visibleCarouselItems = carouselElement.getElementsByClassName("swiper-slide-visible");
    let arr = Array.prototype.slice.call(visibleCarouselItems);
    return arr;
}

function sendProductGroupBlockListingScriptToGTM(productGroupBlockElement: Element) {
    //Get all product elements in the list.
    const itemElements = nodeListToArray(productGroupBlockElement.querySelectorAll('[data-product-group-block-vertical-item]'));
    let listId = productGroupBlockElement.getAttribute('data-product-group-block-vertical-id');
    let listName = productGroupBlockElement.getAttribute('data-product-group-block-vertical-title');
    sendViewListAnalyticsScriptToGTM(itemElements, listId, listName);
}

export function sendProductGroupBlockListingScriptsToGTM() {
    //Send 'view item list' event to GTM for each vertical product group block listing on the page.
    const productGroupBlockElements = nodeListToArray(document.querySelectorAll('[data-product-group-block-vertical]'));
    productGroupBlockElements.forEach((element, index) => {
        sendProductGroupBlockListingScriptToGTM(element)
    });
}

export function sendOnlineCourseSeriesListScriptToGTM() {
    const onlineCourseSeriesElement = document.querySelector('[data-online-course-series]');
    if (onlineCourseSeriesElement) {
        const itemElements = nodeListToArray(onlineCourseSeriesElement.querySelectorAll('[data-online-course-series-item]'));
        let listId = onlineCourseSeriesElement.getAttribute('data-online-course-series-list-id');
        let listName = onlineCourseSeriesElement.getAttribute('data-online-course-series-list-name');
        sendViewListAnalyticsScriptToGTM(itemElements, listId, listName);
    }
}

export function sendShopSearchResultListScriptToGTM() {
    const searchResultsElement = document.querySelector('[data-search-results]');
    if (searchResultsElement === null) return;
    //Get all product elements in the list.
    var shopItems = searchResultsElement.querySelectorAll('[data-shop-search-result]');
    if (shopItems === null) return;
    const itemElements = nodeListToArray(searchResultsElement.querySelectorAll('[data-shop-search-result]'));
    if (itemElements === null || itemElements.length == 0) return;

    let listId = "Search Page";
    let listName = "Search Page";
    sendViewListAnalyticsScriptToGTM(itemElements, listId, listName);
}

window.sendAddToCartScriptToGTM = function (element: any) {
    sendAddToCartScriptToGTM(element);
}
export function sendAddToCartScriptToGTM(element: Element) {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

    //get info about each product item via data attributes
    var itemTitle = element.getAttribute('data-add-to-cart-title');
    var itemKey = element.getAttribute('data-add-to-cart-key');
    var itemPrice = element.getAttribute('data-add-to-cart-price');
    var itemCategory = element.getAttribute('data-add-to-cart-category');
    var item: any = getListItem(itemKey, itemTitle, itemPrice, itemCategory)
    var totalPrice = itemPrice;
    var quantityInput = document.getElementById('amount') as HTMLInputElement;
    if (quantityInput) {
        item = { ...item, 'quantity': quantityInput.value }
        let price = parseFloat(itemPrice);
        let quantity = parseInt(quantityInput.value);
        if (price && quantity) {
            totalPrice = (price * quantity).toFixed(2);
        }
    }
    let tag = {
        'event': 'add_to_cart',
        'ecommerce':
        {
            'currency': 'USD',
            'value': totalPrice,
            'items': [ item ]
        }
    };

    console.log(`Sending tag to data layer: ${JSON.stringify(tag)}`);
    (window as any).dataLayer.push(tag);
}